// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CsvMetadata_panel__XezrS {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: var(--space-2) 0 var(--space-3);
  font-size: 0.875rem;
}

.CsvMetadata_facts__RpbWK {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1) var(--space-3);
}

.CsvMetadata_score__\\+dpmB {
  margin: 0;
}

.CsvMetadata_hint__7G2zJ {
  color: var(--text-secondary);
}

.CsvMetadata_table__Pd1Ql {
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
}

.CsvMetadata_table__Pd1Ql th,
.CsvMetadata_table__Pd1Ql td {
  text-align: left;
  padding: 2px var(--space-3) 2px 0;
  border-bottom: 1px solid var(--border-light);
}

.CsvMetadata_table__Pd1Ql th {
  color: var(--text-secondary);
  font-weight: 600;
}

.CsvMetadata_extra__yCx1B {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 2px var(--space-3);
  margin: 0;
}

.CsvMetadata_extra__yCx1B dt {
  color: var(--text-secondary);
}

.CsvMetadata_extra__yCx1B dd {
  margin: 0;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/CsvMetadata.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB","sourcesContent":[".panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  margin: var(--space-2) 0 var(--space-3);\n  font-size: 0.875rem;\n}\n\n.facts {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-1) var(--space-3);\n}\n\n.score {\n  margin: 0;\n}\n\n.hint {\n  color: var(--text-secondary);\n}\n\n.table {\n  border-collapse: collapse;\n  font-variant-numeric: tabular-nums;\n}\n\n.table th,\n.table td {\n  text-align: left;\n  padding: 2px var(--space-3) 2px 0;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.table th {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.extra {\n  display: grid;\n  grid-template-columns: max-content minmax(0, 1fr);\n  gap: 2px var(--space-3);\n  margin: 0;\n}\n\n.extra dt {\n  color: var(--text-secondary);\n}\n\n.extra dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `CsvMetadata_panel__XezrS`,
	"facts": `CsvMetadata_facts__RpbWK`,
	"score": `CsvMetadata_score__+dpmB`,
	"hint": `CsvMetadata_hint__7G2zJ`,
	"table": `CsvMetadata_table__Pd1Ql`,
	"extra": `CsvMetadata_extra__yCx1B`
};
export default ___CSS_LOADER_EXPORT___;
